/**
 * Binding-related React Query hooks
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { identityServiceClient } from '../client'
import { BindingCreate, BindingsQueryParams, BindingUpdate, BindingDeleteRequest } from '../'

// Query hooks for bindings
export const useBindings = (params?: BindingsQueryParams) => {
  return useQuery({
    queryKey: ['bindings', params],
    queryFn: async () => {
      const response = await identityServiceClient.GET('/bindings', {
        params: { query: params },
      })
      if (response.error) throw response.error
      return response.data
    },
  })
}

// Mutation hooks for bindings
export const useCreateBinding = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (bindingData: BindingCreate) => {
      const response = await identityServiceClient.POST('/bindings', {
        body: bindingData,
      })
      if (response.error) throw response.error
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bindings'] })
    },
  })
}

export const useUpdateBinding = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (bindingData: BindingUpdate) => {
      const response = await identityServiceClient.PUT('/bindings', {
        body: bindingData,
      })
      if (response.error) throw response.error
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bindings'] })
    },
  })
}

export const useDeleteBinding = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (bindingData: BindingDeleteRequest) => {
      const response = await identityServiceClient.DELETE('/bindings', {
        body: bindingData,
      })
      if (response.error) throw response.error
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['bindings'] })
    },
  })
}
